import { Role } from '@core/referential/role.enum'

export const isAssignedToEquipmentRoles = [Role.MANAGER, Role.OPERATOR, Role.OPERATOR_RESTRICTED]

export function isAuthorizedToEditUser(currentUserRole: Role | undefined, userRole: Role) {
  if (currentUserRole === Role.ADMIN) {
    return true
  }

  if (currentUserRole === Role.ADMIN_SITE) {
    return userRole !== Role.ADMIN
  }

  if (currentUserRole === Role.MANAGER) {
    return userRole !== Role.ADMIN && userRole !== Role.ADMIN_SITE
  }

  return false
}
